export default __webpack_public_path__ + "static/media/banner.55699dca.png";